import {
  Wrap,
  Text,
  Stack,
  WrapItem,
  Avatar,
  AvatarBadge,
  Box,
  InputGroup,
  Input,
  InputRightElement,
  IconButton,
} from '@chakra-ui/react'
import React, { useCallback } from 'react'
import { truncateWithEllipsis } from 'utils/string-formatters'
import { useAgentInfo } from '../contact-center.hooks'
import { useDialerState } from './dialer.hooks'

export type DialerHeaderProps = {
  searchQuery?: string
  setSearchQuery: any
}

export const DialerHeader: React.FC<DialerHeaderProps> = ({ searchQuery, setSearchQuery }) => {
  const { dialerState, setDialerState } = useDialerState()

  const openDialer = useCallback(() => {
    if (!dialerState.isOpen) {
      setDialerState(prev => ({ ...prev, isOpen: true }))
    }
  }, [])

  const { name: agentName, phoneNo: agentPhoneNo } = useAgentInfo()

  return (
    <Box bg="#F2F7FE" p="5">
      <Wrap spacing="10px">
        <WrapItem>
          <Avatar boxSize="38px">
            <AvatarBadge boxSize="0.8em" bg={dialerState.isCalling ? 'red.500' : 'green.500'} />
          </Avatar>
        </WrapItem>

        <WrapItem>
          <Stack>
            <Text fontFamily="Poppins" fontSize="12px" fontWeight="500" color="gray.700" isTruncated={true}>
              {truncateWithEllipsis(agentName, 30)}
            </Text>
            <Text fontFamily="Poppins" fontSize="12px" fontWeight="400" color="gray.700">
              {agentPhoneNo}
            </Text>
          </Stack>
        </WrapItem>
        <WrapItem>
          {
          //<Icon as={HeadPhoneIcon} width="24px" height="24px" pos="relative" />
          }
        </WrapItem>
      </Wrap>
      <Box mt="25px">
        <Box>
          <InputGroup size="md">
            <Input
              placeholder="Enter a name or number"
              pr="5.5rem"
              type="text"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              isDisabled={dialerState.isCalling}
            />
            <InputRightElement width="44px" mr="10px">
              <IconButton
                variant="none"
                h="1.7rem"
                aria-label="open phone dialer"
                bg="#345EA6"
                borderRadius="13px"
                minW="44px"
                icon={<PhoneDialerIcon />}
                onClick={openDialer}
                isDisabled={dialerState.isCalling}
                
              />
            </InputRightElement>
          </InputGroup>
        </Box>
      </Box>
    </Box>
  )
}

/*const HeadPhoneIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M20 12V10.293C20 5.851 16.521 2.132 12.245 2.003C10.041 1.952 7.994 2.739 6.429 4.259C5.65744 5.00232 5.04444 5.89423 4.62697 6.88092C4.2095 7.86761 3.99623 8.92864 4 10V12C2.897 12 2 12.897 2 14V18C2 19.103 2.897 20 4 20H6V10C5.99705 9.19649 6.15688 8.40071 6.46985 7.66065C6.78282 6.9206 7.24245 6.2516 7.821 5.694C8.39712 5.13318 9.08047 4.69436 9.83014 4.4038C10.5798 4.11324 11.3804 3.97692 12.184 4.003C15.392 4.099 18 6.921 18 10.293V20H20C21.103 20 22 19.103 22 18V14C22 12.897 21.103 12 20 12Z"
        fill="#718096"
      />
      <path d="M7 12H9V20H7V12ZM15 12H17V20H15V12Z" fill="#718096" />
    </svg>
  )
}*/

export const PhoneDialerIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M6 5C6.26522 5 6.51957 4.89464 6.70711 4.70711C6.89464 4.51957 7 4.26522 7 4C7 3.73478 6.89464 3.48043 6.70711 3.29289C6.51957 3.10536 6.26522 3 6 3C5.73478 3 5.48043 3.10536 5.29289 3.29289C5.10536 3.48043 5 3.73478 5 4C5 4.26522 5.10536 4.51957 5.29289 4.70711C5.48043 4.89464 5.73478 5 6 5ZM6 9C6.26522 9 6.51957 8.89464 6.70711 8.70711C6.89464 8.51957 7 8.26522 7 8C7 7.73478 6.89464 7.48043 6.70711 7.29289C6.51957 7.10536 6.26522 7 6 7C5.73478 7 5.48043 7.10536 5.29289 7.29289C5.10536 7.48043 5 7.73478 5 8C5 8.26522 5.10536 8.51957 5.29289 8.70711C5.48043 8.89464 5.73478 9 6 9ZM7 12C7 12.2652 6.89464 12.5196 6.70711 12.7071C6.51957 12.8946 6.26522 13 6 13C5.73478 13 5.48043 12.8946 5.29289 12.7071C5.10536 12.5196 5 12.2652 5 12C5 11.7348 5.10536 11.4804 5.29289 11.2929C5.48043 11.1054 5.73478 11 6 11C6.26522 11 6.51957 11.1054 6.70711 11.2929C6.89464 11.4804 7 11.7348 7 12ZM10 5C10.2652 5 10.5196 4.89464 10.7071 4.70711C10.8946 4.51957 11 4.26522 11 4C11 3.73478 10.8946 3.48043 10.7071 3.29289C10.5196 3.10536 10.2652 3 10 3C9.73478 3 9.48043 3.10536 9.29289 3.29289C9.10536 3.48043 9 3.73478 9 4C9 4.26522 9.10536 4.51957 9.29289 4.70711C9.48043 4.89464 9.73478 5 10 5ZM11 8C11 8.26522 10.8946 8.51957 10.7071 8.70711C10.5196 8.89464 10.2652 9 10 9C9.73478 9 9.48043 8.89464 9.29289 8.70711C9.10536 8.51957 9 8.26522 9 8C9 7.73478 9.10536 7.48043 9.29289 7.29289C9.48043 7.10536 9.73478 7 10 7C10.2652 7 10.5196 7.10536 10.7071 7.29289C10.8946 7.48043 11 7.73478 11 8ZM10 13C10.2652 13 10.5196 12.8946 10.7071 12.7071C10.8946 12.5196 11 12.2652 11 12C11 11.7348 10.8946 11.4804 10.7071 11.2929C10.5196 11.1054 10.2652 11 10 11C9.73478 11 9.48043 11.1054 9.29289 11.2929C9.10536 11.4804 9 11.7348 9 12C9 12.2652 9.10536 12.5196 9.29289 12.7071C9.48043 12.8946 9.73478 13 10 13ZM11 16C11 16.2652 10.8946 16.5196 10.7071 16.7071C10.5196 16.8946 10.2652 17 10 17C9.73478 17 9.48043 16.8946 9.29289 16.7071C9.10536 16.5196 9 16.2652 9 16C9 15.7348 9.10536 15.4804 9.29289 15.2929C9.48043 15.1054 9.73478 15 10 15C10.2652 15 10.5196 15.1054 10.7071 15.2929C10.8946 15.4804 11 15.7348 11 16ZM14 5C14.2652 5 14.5196 4.89464 14.7071 4.70711C14.8946 4.51957 15 4.26522 15 4C15 3.73478 14.8946 3.48043 14.7071 3.29289C14.5196 3.10536 14.2652 3 14 3C13.7348 3 13.4804 3.10536 13.2929 3.29289C13.1054 3.48043 13 3.73478 13 4C13 4.26522 13.1054 4.51957 13.2929 4.70711C13.4804 4.89464 13.7348 5 14 5ZM15 8C15 8.26522 14.8946 8.51957 14.7071 8.70711C14.5196 8.89464 14.2652 9 14 9C13.7348 9 13.4804 8.89464 13.2929 8.70711C13.1054 8.51957 13 8.26522 13 8C13 7.73478 13.1054 7.48043 13.2929 7.29289C13.4804 7.10536 13.7348 7 14 7C14.2652 7 14.5196 7.10536 14.7071 7.29289C14.8946 7.48043 15 7.73478 15 8ZM14 13C14.2652 13 14.5196 12.8946 14.7071 12.7071C14.8946 12.5196 15 12.2652 15 12C15 11.7348 14.8946 11.4804 14.7071 11.2929C14.5196 11.1054 14.2652 11 14 11C13.7348 11 13.4804 11.1054 13.2929 11.2929C13.1054 11.4804 13 11.7348 13 12C13 12.2652 13.1054 12.5196 13.2929 12.7071C13.4804 12.8946 13.7348 13 14 13Z"
        fill="white"
      />
    </svg>
  )
}
